// The single "before Continue shopping" divider (.ai-cart__divider-* in
// sections/main-cart-items.liquid) plays the usual scroll-triggered grow-in reveal once, the
// first time the cart page loads — same as every other stacked card's own divider on this
// site. But an AJAX quantity/remove update re-renders it from scratch (a plain, unobserved
// element straight from the server's HTML, since it lives inside .js-contents), and a brand
// new .js-grow-observe element replays that grow-in on its own the instant it's inserted — so
// every single edit "flashed" a short line stretching open again, easy to mistake for some kind
// of scroll indicator rather than the one-time reveal it's meant to be.
//
// Neutralized synchronously in the same cartUpdate handler already used site-wide for this
// exact kind of post-swap cleanup (assets/header.js does the same for the cart badge):
// stripping js-grow-observe defeats both the element's own collapsed starting transform and
// the CSS rule that triggers the animation, and — because this runs in the same task as the
// .js-contents swap that created the element, before the browser has painted a single frame of
// it — the animation never visibly plays at all, not even for an instant.
(function () {
  function skipReplay() {
    document.querySelectorAll('[data-divider-line].js-grow-observe').forEach(function (el) {
      el.classList.remove('js-grow-observe');
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, skipReplay);
  }
})();
